__webpack_require__.p = "/reports-table-flickering/referrals-hub/";